import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges } from "@angular/core";
import { FullCalendarModule } from "@fullcalendar/angular";
import { CalendarOptions } from "@fullcalendar/core";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

@Component({
  selector: "app-court-day",
  imports: [CommonModule, FullCalendarModule],
  template: `<div class="court-columns">
    <section *ngFor="let column of columns">
      <h3>{{ column.name }}</h3>
      <full-calendar [options]="column.options" />
    </section>
  </div>`,
  styles: [
    `
      :host {
        display: block;
        overflow: auto;
        flex: 1;
        min-height: 0;
      }
      .court-columns {
        display: flex;
        min-width: 100%;
        align-items: flex-start;
      }
      section {
        flex: 1;
        min-width: 240px;
      }
      h3 {
        position: sticky;
        top: 0;
        z-index: 5;
        background: #f8fafc;
        padding: 12px;
        text-align: center;
        font-weight: 600;
        border: 1px solid #e2e8f0;
      }
    `,
  ],
})
export class CourtDayComponent implements OnChanges {
  @Input() courts: any[] = [];
  @Input() events: any[] = [];
  @Input() date = "";
  @Input() options: CalendarOptions = {};
  columns: { name: string; options: CalendarOptions }[] = [];
  private previousKey = "";
  private previousEvents?: any[];
  private previousOptions?: CalendarOptions;

  ngOnChanges() {
    const key = `${this.date}:${this.courts.map((c) => c._id).join(",")}`;
    if (
      key === this.previousKey &&
      this.events === this.previousEvents &&
      this.options === this.previousOptions
    )
      return;
    this.previousKey = key;
    this.previousEvents = this.events;
    this.previousOptions = this.options;
    this.columns = this.courts.map((court) => ({
      name: court.name,
      options: {
        ...this.options,
        plugins: [timeGridPlugin, interactionPlugin],
        initialView: "timeGridDay",
        initialDate: this.date || undefined,
        headerToolbar: false,
        dayHeaders: false,
        height: "auto",
        datesSet: undefined,
        events: this.events.filter(
          (event) =>
            String(
              event.extendedProps?.courtId ??
                event.extendedProps?.block?.courtId,
            ) === String(court._id),
        ),
        select: (arg: any) => {
          const callback = this.options.select;
          if (typeof callback === "function")
            callback({ ...arg, courtId: court._id });
        },
      },
    }));
  }
}
